"use strict";
var windowHeight = window.innerHeight,
    windowHeightExtra = 0,
    safari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent),
    mobile = /Mobi/.test(navigator.userAgent);

if (safari && !mobile) {
  windowHeightExtra = window.outerHeight - window.innerHeight;
}
if (mobile) {
  windowHeight = window.screen.availHeight;
  windowHeightExtra = (window.screen.availHeight - window.innerHeight) / 2;
}

var positionParallax = function(e, t, a, i) {
  var n = e.top / t - windowHeightExtra;
  a[i].style.top = n + "px";
};

var animateParallax = function(e, t) {
  var rects = [];
  for (var a = 0; a < e.length; a++) {
    if (e[a] && e[a].parentElement && e[a].parentElement.parentElement) {
      rects.push(e[a].parentElement.parentElement.getBoundingClientRect());
    } else {
      rects.push(null);
    }
  }
  for (var a = 0; a < e.length; a++) {
    var i = rects[a];
    if (i && 0 <= i.top + i.height && i.top <= windowHeight) {
      positionParallax(i, t, e, a);
    }
  }
};

var calculateHeight = function(e, t) {
  var data = [];
  for (var a = 0; a < e.length; a++) {
    if (e[a] && e[a].parentElement && e[a].parentElement.parentElement) {
      var parent = e[a].parentElement.parentElement;
      data.push({
        rect: parent.getBoundingClientRect(),
        offsetTop: parent.offsetTop
      });
    } else {
      data.push(null);
    }
  }
  for (var a = 0; a < e.length; a++) {
    if (!data[a]) continue;
    var i = data[a].rect,
        n = data[a].offsetTop,
        o = (windowHeight - i.height) / 2,
        r = windowHeight > i.height + n ? i.height + n - n / t : i.height + 2 * (o - o / t);
    e[a].style.height = r + 2 * windowHeightExtra + "px";
    positionParallax(i, t, e, a);
  }
};

var universalParallax = function() {
  this.init = function(i) {
    if (void 0 === i) i = {};
    i = {
      speed: void 0 !== i.speed ? i.speed : 1.5,
      className: void 0 !== i.className ? i.className : "parallax"
    };

    var n = Array.from(document.getElementsByClassName(i.className));
    if (!n.length) return;

    for (var e = 0; e < n.length; e++) {
      var t = document.createElement("div");
      n[e].parentNode.insertBefore(t, n[e]);
      t.appendChild(n[e]);
      var a = n[e].parentElement;
      a.className += "parallax__container";
      var o = n[e].dataset.parallaxImage;
      if (void 0 !== o) {
        n[e].style.backgroundImage = "url(" + o + ")";
        if (1 === n[e].classList.length && "parallax" === n[e].classList[0]) {
          n[e].style.backgroundRepeat = "no-repeat";
          n[e].style.backgroundPosition = "center";
          n[e].style.backgroundSize = "cover";
        }
      }
    }

    var parentsToSetRelative = [];
    for (var e = 0; e < n.length; e++) {
      var grandParent = n[e].parentElement.parentElement;
      if (grandParent && window.getComputedStyle(grandParent, null).getPropertyValue("position") !== "relative") {
        parentsToSetRelative.push(grandParent);
      }
    }
    parentsToSetRelative.forEach(function(el) {
      el.style.position = "relative";
    });

    var onReady = function() {
      var speed = i.speed < 1 ? 1 : i.speed;
      calculateHeight(n, speed);
      if (!mobile) {
        window.addEventListener("resize", function() {
          windowHeight = window.innerHeight;
          calculateHeight(n, speed);
        }, { passive: true });
      }
      var ticking = false;
      window.addEventListener("scroll", function() {
        if (!ticking) {
          window.requestAnimationFrame(function() {
            animateParallax(n, speed);
            ticking = false;
          });
          ticking = true;
        }
      }, { passive: true });
    };

    if (document.readyState === "complete") {
      onReady();
    } else {
      document.addEventListener("readystatechange", function(e) {
        if (e.target.readyState === "complete") {
          onReady();
        }
      });
    }
  };
};